import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../components/SpinContext";
import {
  ShowMessage,
  CustomInput,
  CustomButton,
  CustomTitle,
} from "../../components";
import { Col, Flex, Form, Row, message } from "antd";
import { ForgotPasswordApi } from "../../api's/auth";
import CheckMarkIcon from "../../assets/images/check-mark.png";

const ForgotPassword = () => {
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isFormValid, setIsFormValid] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleForgotPassword = (values) => {
    showSpin();
    const { email } = values;
    ForgotPasswordApi(email)
      .then((res) => {
        if (res?.data?.data.is_success) {
          setEmailSent(true);
          // setTimeout(() => {
          //   navigate('/verify-email')
          // }, 500);
          message.success("A reset link has been sent to your email.");
        } else {
          message.error(res?.data?.data.message || "Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        message.error("Failed to send reset link. Please try again later.");
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  return (
    <>
      <div className="forgot-pass">
        {emailSent ? (
          <Flex
            vertical
            align="center"
            justify="center"
            style={{ height: "inherit" }}
          >
            <ShowMessage
              heading="Email Sent Successfully"
              icon={CheckMarkIcon}
              text="Check your inbox for the password reset link."
            />
            <CustomButton
              text="Back to Login"
              block="block"
              height="48px"
              bgColor="#000"
              color="#fff"
              borderRadius="8px"
              fontSize={16}
              fontWeight={500}
              onClick={() => navigate("/login")}
            />
          </Flex>
        ) : (
          <Flex
            vertical
            align="center"
            justify="center"
            style={{ height: "inherit" }}
          >
            <ShowMessage
              heading="Forgot Your Password?"
              text="Enter your email address and we will send you a reset link."
              paragraphFontSize="14px"
            >
              <Flex justify="center">
                <Form
                  form={form}
                  name="forgotPasswordForm"
                  onFinish={handleForgotPassword}
                  layout="vertical"
                  autoComplete="off"
                >
                  <Row gutter={[16, 24]}>
                    <Col span={24}>
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your email address",
                          },
                          {
                            type: "email",
                            message: "Enter a valid email address",
                          },
                        ]}
                      >
                        <CustomInput
                          type="email"
                          placeholder="Enter your email"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item>
                        <CustomButton
                          text="Send Reset Link"
                          block="block"
                          height="48px"
                          bgColor="#000"
                          color="#fff"
                          borderRadius="8px"
                          fontSize={16}
                          fontWeight={500}
                          htmlType="submit"
                          isFormValid={isFormValid}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Flex>
            </ShowMessage>
          </Flex>
        )}
      </div>
    </>
  );
};

export default ForgotPassword;
